export const SENDING_REQUEST = 'TEMPLATESLIST_SENDING_REQUEST';
export const GETALL_SUCCESS = 'TEMPLATESLIST_GETALL_SUCCESS';
export const GETALL_FAILURE = 'TEMPLATESLIST_GETALL_FAILURE';